import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "#0178D9";

function IconAzureDevOps({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="m0 5.901 1.498-1.976L7.1 1.646V0l4.914 3.594L1.976 5.542v5.485L0 10.456V5.901zm16-2.966v9.768l-3.836 3.265-6.2-2.037v2.037l-3.988-4.943 10.04 1.198V3.595L16 2.934z"/>
        </svg>
    );
}

export default IconAzureDevOps;
